import { Observable } from 'rxjs';
import { Inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { ApiClientConfig } from '../api-client-config';
import { CreateResponse } from 'it/primatoo/openapi/api/common/schemas/CreateResponse';
import { ListUserForMenuResponse } from 'it/primatoo/openapi/api/org/schemas/user/ListUserForMenuResponse';
import { CreateUserResourceRequest } from 'it/primatoo/openapi/api/org/schemas/userresource/CreateUserResourceRequest';

@Injectable({
  providedIn: 'root'
})
export class UsersResourcesV2Service {

  private readonly endpointV2: string;

  constructor(
    @Inject(ApiClientConfig) private config: ApiClientConfig,
    public httpClient: HttpClient) {
    this.endpointV2 = this.config.endPoint + '/api/org/v2/user-resources/';
  }

  public getMenu(): Observable<ListUserForMenuResponse> {
    const url = this.endpointV2 + 'menu/';
    return this.httpClient.get<ListUserForMenuResponse>(url);
  }

  public create(requestBody: CreateUserResourceRequest): Observable<CreateResponse> {
    const url = this.endpointV2;
    return this.httpClient.post<CreateResponse>(url, requestBody);
  }
}
